<!-- 专利求购列表 -->
<template>
	<div>
		<!-- 顶部欢迎及注册登录按钮导航 -->
		<header-top />
		<!-- 顶部公司logo及导航栏 -->
		<logo-head></logo-head>
		<!-- 导航栏 -->
		<nav-head></nav-head>
		<div style="background-color:#f7f7f7;overflow: hidden;">
			<!-- 求购列表 -->
			<div class="purchaseList">
				<div class="pt-4 pb-4">
					<div class="d-flex" style="justify-content: space-between;">
						<div></div>
						<h3 class="pb-3">{{$route.query.type}}求购</h3>
						<el-button style="position: relative;right:50px;top: 2px;" @click="myInfoUp">我要发布</el-button>
					</div>
					<el-card shadow="hover" class="listCard" v-for="(item,index) in wantBuyArr" :key="index"
					@click="detailShow(item.id,`${$route.query.type}求购`,'/purchaseList')">
						  <el-descriptions
						    class="margin-top"
						    :title="item.name"
						    :column="3"
						    :size="size"
						    border
						  >
						    <el-descriptions-item>
						      <template #label>
						        <div class="cell-item">
						          发布人
						        </div>
						      </template>
						      {{item.userName}}
						    </el-descriptions-item>
						    <el-descriptions-item>
						      <template #label>
						        <div class="cell-item">
						          类型
						        </div>
						      </template>
						      {{item.type}}
						    </el-descriptions-item>
						    <el-descriptions-item>
						      <template #label>
						        <div class="cell-item">
						          类别
						        </div>
						      </template>
						      {{item.category}}
						    </el-descriptions-item>
						    <el-descriptions-item>
						      <template #label>
						        <div class="cell-item">
						          发布时间
						        </div>
						      </template>
						      {{item.updateAt}}
						    </el-descriptions-item>
						    <el-descriptions-item>
						      <template #label>
						        <div class="cell-item">
						          投资意向金额
						        </div>
						      </template>
						      {{item.money}}
						    </el-descriptions-item>
						  </el-descriptions>
					</el-card>
				</div>
				<!-- 分页器 -->
				<div style="text-align: center;" class="py-4">
					<el-pagination background layout="prev, pager, next"
					@current-change="getPatentWantBuyArr" :current-page="paging.currPage"
					:page-size="paging.everySize" :total="paging.allNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 联系购买填写称呼弹窗 -->
		<el-dialog v-model="wantBuyDialog" title="怎么称呼您" width="300px">
		    <el-form :model="wantBuyForm">
		        <el-form-item label="请输入您的称呼" :label-width="formLabelWidth">
		            <el-input v-model="wantBuyForm.name" autocomplete="off"></el-input>
		        </el-form-item>
		        <el-form-item label="" prop="sex">
		            <el-radio-group v-model="wantBuyForm.sex">
		                <el-radio label="先生"></el-radio>
		                <el-radio label="女士"></el-radio>
		            </el-radio-group>
		        </el-form-item>
		    </el-form>
		    <template #footer>
		      <span class="dialog-footer">
		        <el-button @click="wantBuyDialog = false">取消</el-button>
		        <el-button type="primary" @click="confirmCommit"
		        >确定</el-button
		        >
		      </span>
		    </template>
		</el-dialog>
		<!-- 填写发布信息弹窗 -->
		<el-dialog v-model="upInfoDialog" title="填写意向" width="500px" center>
		    <el-form :model="upInfoForm">
		        <el-form-item label="您要求购的商品名称或功能简述">
		            <el-input v-model="upInfoForm.name" autocomplete="off"></el-input>
		        </el-form-item>
				<el-form-item label="您的意向投资金额区间(人民币)">
				    <el-input v-model="upInfoForm.money" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="您要求购的类型">
					<el-select v-model="upInfoForm.type" placeholder="您要求购的类型" clearable @change="selectChanged">
						<el-option v-for="item in types" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属类别">
					<el-select v-model="upInfoForm.category" placeholder="您要求购的类别">
						<el-option v-for="item in categories" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="详细需求描述">
				    <el-input v-model="upInfoForm.introduce" autocomplete="off" type="textarea" :rows="4"
					placeholder="请详细描述您的需求"></el-input>
				</el-form-item>
		    </el-form>
		    <template #footer>
		      <span class="dialog-footer">
		        <el-button @click="upInfoDialog = false">取消</el-button>
				  <el-button type="primary" @click="commitBuyInfo">确定</el-button>
		      </span>
		    </template>
		</el-dialog>
		<!-- 底部导航 -->
		<div>
			<Footer :bgColor="'#fafafa'" :border="true"></Footer>
		</div>
	</div>
</template>

<script>
	import {
		ref,
	} from 'vue'
	import HeaderTop from '@/components/headerTop/headerTop.vue'
	import LogoHead from '@/components/logoHead/logoHead.vue'
	import NavHead from '@/components/navHead/navHead.vue'
	import Footer from '@/components/footer/footer.vue'
	import { ShoppingCart } from '@element-plus/icons'
	import { ElNotification } from 'element-plus'
	export default{
		components: {
			HeaderTop,
			LogoHead,
			NavHead,
			ShoppingCart,
			Footer
		},
		setup() {
			// 热门专利
			let hotPatent = ref([])
			// 想要购买弹窗
			let wantBuyDialog = ref(false)
			let upInfoDialog = ref(false)
			// 想要购买的列表
			let wantBuyArr = ref([])
			// 弹窗类别
			let categories = ref([])
			// 个人信息弹窗
			let wantBuyForm = ref({name: '',sex: ''})
			let upInfoForm = ref({name: '',introduce:'',money:'',category:'',type:''})
			// 收藏状态
			let collection = ref(false)
			// 微信二维码
			let wxImg = ref('')
			let hotList = ref([])
			let mbx = ref('')
			let mbxLink = ref('')
			let id = ref(0)
			let type =  ref('')
			let types = ref(['外观专利','实用新型专利','发明专利','商标'])
			let paging = ref({currPage: 1, everySize: 10, allNum: 0})
			//检索条件
			let condition = ref({type:''})
			return {
				hotPatent,
				wantBuyDialog,
				upInfoDialog,
				wantBuyArr,
				wantBuyForm,
				upInfoForm,
				categories,
				collection,
				wxImg,
				hotList,
				mbx,
				mbxLink,
				paging,
				condition,
				id,
				type,
				types
			}
		},
		mounted() {
			this.condition.type = this.$route.query.type
			// 获取热门推荐-热门专利数据
			this.getPatentWantBuyArr()
		},
		methods: {
			selectChanged(value){
				let vm = this
				vm.upInfoForm.category = ''
				//根据value查询类别信息
				vm.axios.get('/api/want/buy/findByType/'+value).then(res => {
					vm.categories = res.data.data
				})
			},
			// 获取专利求购模块
			getPatentWantBuyArr(currentPage){
				let vm = this
				// 区分分页与查询
				if(currentPage){
				   vm.paging.currPage = currentPage;
				} else {
				   vm.paging.currPage = 1;
				} 
				var params = {}
				params.currPage = vm.paging.currPage
				params.everySize = vm.paging.everySize
				params.type = vm.condition.type
				this.axios.get('/api/want/buy/findAll',{params: params}).then(res => {
					vm.wantBuyArr = res.data.data.wantBuys
					vm.paging = res.data.data.pagingBean
				})
			},
			// 我要发布
			myInfoUp(){
				let vm = this
				let token = window.sessionStorage.getItem('token')
				if(!token){
					vm.$router.push('/login')
				}else {
                    let user = JSON.parse(window.sessionStorage.getItem('user'))
                    if (!user.name) {
                        // 打开弹窗
                      vm.wantBuyDialog = true
                    }else{
					  vm.upInfoDialog = true
					}
                }
			},
			// 确认提交称呼表单
			confirmCommit() {
			    let vm = this
				if(!vm.wantBuyForm.name || !vm.wantBuyForm.sex){
					return alert('请您完整填写称呼信息')
				}
			    //提交称呼信息
			    this.axios.post('/api/platform/updateUserInfo', {
			        name: vm.wantBuyForm.name,
			        sex: vm.wantBuyForm.sex
			    }).then(res => {
			        vm.wantBuyDialog = false
			        window.sessionStorage.setItem('user', JSON.stringify(res.data.data))
			        vm.$store.commit('initUser')
					vm.upInfoDialog = true
			    }).catch(err => {
			    })
			},
			// 提交联系购买需求事件
			commitBuyInfo() {
			    let vm = this
			    this.axios.post('/api/want/buy/save',vm.upInfoForm).then(res => {
			        if (res.data.success) {
			            // 成功提示
			            ElNotification({
			                title: '意向提交',
			                message: res.data.msg,
			                type: 'success', //警告:warning,信息:info,失败:danger,成功success
			            })
						vm.upInfoDialog = false
			        } else {
			            // 成功提示
			            ElNotification({
			                title: '意向提交',
			                message: res.data.msg,
			                type: 'danger', //警告:warning,信息:info,失败:danger,成功success
			            })
			        }
			    }).catch(err => {
					vm.upInfoDialog = false
			    })
			},
			// 进入商品详情页
			detailShow(id,mbx,mbxLink){
				let routeData = this.$router.resolve({
					path:'/purchaseDetail',
					query:{
						id:id,
						mbx:mbx,
						mbxLink:mbxLink,
						type:this.condition.type
					}
				})
				window.open(routeData.href, '_blank');
			}
		},
	}
</script>

<style scoped>
	.purchaseList{
		width:1200px;
		min-height: 800px;
		margin: 0 auto;
		background-color: #fff;
		margin-top:20px;
		margin-bottom: 20px;
	}
	.purchaseList .listCard{
		width:1100px;
		min-height:100px;
		margin-left:50px;
		margin-bottom: 20px;
		cursor: pointer;
	}
</style>
<style>
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #C32A1A;
	}
</style>

